













import Vue from 'vue'
import FreeShiftConfigurator from '@/components/master-data/shifts/FreeShiftConfigurator.vue'
import QcqShiftConfigurator from '@/components/master-data/shifts/QcqShiftConfigurator.vue'

interface ComponentData {
  activeTab: string | null
}

export default Vue.extend({
  name: 'MasterDataShiftsPage',

  components: {
    FreeShiftConfigurator,
    QcqShiftConfigurator
  },

  data (): ComponentData {
    return {
      activeTab: null,

    }

  },
})
